export const URL_RESULT = process.env.REACT_APP_URL_RESULT;

export const PAGE_SIZE = 10;
export const TIME_OTP_DESTROY = 60;
